// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
#skip-actions.vue-skip-actions:focus-within {
  top: 0 !important;
  left: 0 !important;
  width: 100vw;
  height: 100vh;
  padding: var(--body-container-margin) !important;
  backdrop-filter: brightness(50%);
}/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-6922a9df] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.vue-skip-actions__container[data-v-6922a9df] {
  background-color: var(--color-main-background);
  border-radius: var(--border-radius-large);
  padding: 22px;
}
.vue-skip-actions__headline[data-v-6922a9df] {
  font-weight: bold;
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 12px;
}
.vue-skip-actions__buttons[data-v-6922a9df] {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.vue-skip-actions__buttons > *[data-v-6922a9df] {
  flex: 1 0 fit-content;
}
.vue-skip-actions__image[data-v-6922a9df] {
  margin-top: 12px;
}
.vue-skip-actions__image[data-v-6922a9df]:dir(rtl) {
  transform: rotateY(180deg);
}
.content[data-v-6922a9df] {
  box-sizing: border-box;
  margin: var(--body-container-margin);
  margin-top: var(--header-height);
  display: flex;
  width: calc(100% - var(--body-container-margin) * 2);
  border-radius: var(--body-container-radius);
  height: var(--body-height);
  overflow: hidden;
  padding: 0;
}
.content[data-v-6922a9df]:not(.with-sidebar--full) {
  position: fixed;
}
.content[data-v-6922a9df] * {
  box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcContent-DH4tX3N4.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gDAAgD;EAChD,gCAAgC;AAClC,CAAC;;;EAGC;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,8CAA8C;EAC9C,yCAAyC;EACzC,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,gCAAgC;EAChC,aAAa;EACb,oDAAoD;EACpD,2CAA2C;EAC3C,0BAA0B;EAC1B,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n#skip-actions.vue-skip-actions:focus-within {\n  top: 0 !important;\n  left: 0 !important;\n  width: 100vw;\n  height: 100vh;\n  padding: var(--body-container-margin) !important;\n  backdrop-filter: brightness(50%);\n}/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-6922a9df] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.vue-skip-actions__container[data-v-6922a9df] {\n  background-color: var(--color-main-background);\n  border-radius: var(--border-radius-large);\n  padding: 22px;\n}\n.vue-skip-actions__headline[data-v-6922a9df] {\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 30px;\n  margin-bottom: 12px;\n}\n.vue-skip-actions__buttons[data-v-6922a9df] {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n.vue-skip-actions__buttons > *[data-v-6922a9df] {\n  flex: 1 0 fit-content;\n}\n.vue-skip-actions__image[data-v-6922a9df] {\n  margin-top: 12px;\n}\n.vue-skip-actions__image[data-v-6922a9df]:dir(rtl) {\n  transform: rotateY(180deg);\n}\n.content[data-v-6922a9df] {\n  box-sizing: border-box;\n  margin: var(--body-container-margin);\n  margin-top: var(--header-height);\n  display: flex;\n  width: calc(100% - var(--body-container-margin) * 2);\n  border-radius: var(--body-container-radius);\n  height: var(--body-height);\n  overflow: hidden;\n  padding: 0;\n}\n.content[data-v-6922a9df]:not(.with-sidebar--full) {\n  position: fixed;\n}\n.content[data-v-6922a9df] * {\n  box-sizing: border-box;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
